import AitiProductVariantsSelection from './variants/selection.mjs';
import AitiProductVariantGroup from './variants/group.mjs';

/**
 * @class
 * @param {AitiProductView} view
 */
var AitiProductVariants = function(view) {

    let _this = this;

    this.view = view;

    /** @var {Object.<string, AitiProductVariantGroup>} */
    this._groups = {};

    this.init = function(groups) {
        if (!groups) {
            throw new TypeError('Argument 1 is not defined');
        }

        this._groups = {};

        for (let i in groups) {
            if (groups.hasOwnProperty(i)) {
                this._groups[groups[i]['id']] = new AitiProductVariantGroup(groups[i]);
            }
        }

        DeferredEvents.trigger(AitiProductVariants.EVENT_INIT_AFTER);
        return this;
    };

    /** @returns {AitiProductView} */
    this.getView = function() {
        return this.view;
    };

    /** @returns {AitiProductVariantsSelection} */
    this.getSelection = function() {
        return this._selection;
    };

    this.getGroups = function() {
        return this._groups;
    };

    /** @returns {AitiProductVariantGroup} */
    this.getGroup = function(id) {
        return this.getGroups()[id];
    };

    /**
     * @param {string} optionId
     * @returns {AitiProductVariantGroupOption}
     */
    this.getGroupOption = function(optionId) {
        for (let id in this.getGroups()) {
            if (this.getGroup(id) && this.getGroup(id).getOption(optionId)) {
                return this.getGroup(id).getOption(optionId);
            }
        }

        return null;
    };

    /** @returns {AitiProductVariantGroup|null} */
    this.getCurrentGroup = function() {
        for (let id in this.getGroups()) {
            if (this.getGroups().hasOwnProperty(id) && this.getGroup(id).isCurrent()) {
                return this.getGroup(id);
            }
        }

        return null;
    };

    /** @param {AitiProductVariantGroup|string} group */
    this.setCurrentGroup = function(group) {
        if (typeof group === 'string' || group instanceof String) {
            group = this.getGroup(group);
        }

        let oldGroup = this.getCurrentGroup();

        if (oldGroup) {
            oldGroup.setCurrent(false);
        }

        if (group) {
            group.setCurrent(true);
        }

        if (!oldGroup || !group || oldGroup.getId() != group.getId()) {
            this.setCurrentGroupOption(null);
        }

        if (group && Object.keys(group.getOptions()).length == 1) {
            this.changeGroupOption(Object.keys(group.getOptions())[0]);
        }

        this.getSelection().updateGroup();
        this.getSelection().updateGroupOption();

        return this;
    }

    /** @returns {AitiProductVariantGroupOption|null} */
    this.getCurrentGroupOption = function() {
        let currentGroup = this.getCurrentGroup();

        if (currentGroup) {
            for (let id in currentGroup.getOptions()) {
                if (currentGroup.getOption(id) && currentGroup.getOption(id).isCurrent()) {
                    return currentGroup.getOption(id);
                }
            }
        }

        return null;
    };

    /** @param {AitiProductVariantGroupOption|string} option */
    this.setCurrentGroupOption = function(option) {
        if (typeof option === 'string' || option instanceof String) {
            option = this.getGroupOption(option);
        }

        if (this.getCurrentGroupOption()) {
            this.getCurrentGroupOption().setCurrent(false);
        }

        if (option) {
            option.setCurrent(true);
        }

        this.getSelection().updateGroupOption();

        return this;
    };

    /**
     * @param {AitiProductVariantGroup|string} group
     * @return {JQuery.Deferred}
     */
    this.changeGroup = function(group) {
        if (typeof group === 'string' || group instanceof String) {
            group = this.getGroup(group);
        }

        return jQuery.Deferred(function() {
            let deferred = this;

            if (_this.getCurrentGroup() && _this.getCurrentGroup().getId() == group.getId()) {
                deferred.resolve();
                return;
            }

            let data = {group: group};
            DeferredEvents.trigger(AitiProductVariants.EVENT_GROUP_CHANGE_BEFORE, data).done(function() {
                _this.setCurrentGroup(data.group);
                DeferredEvents.trigger(AitiProductVariants.EVENT_GROUP_CHANGE_AFTER, data);
                deferred.resolve();
            }).fail(function() {
                deferred.reject();
            });
        });
    };

    /**
     * @param {AitiProductVariantGroupOption|string} option
     * @return {JQuery.Deferred}
     */
    this.changeGroupOption = function(option) {
        if (typeof option === 'string' || option instanceof String) {
            option = this.getGroupOption(option);
        }

        if (this.getCurrentGroupOption() && this.getCurrentGroupOption().getId() == option.getId()) {
            return jQuery.Deferred(function() {
                this.resolve();
            });
        }

        return jQuery.Deferred(function() {
            let deferred = this;

            let data = {option: option};
            return DeferredEvents.trigger(AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_BEFORE, data).done(function() {
                _this.setCurrentGroupOption(data.option);
                DeferredEvents.trigger(AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_AFTER, data);
                deferred.resolve();
            }).fail(function() {
                deferred.reject();
            });
        });
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onInitAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductVariants.EVENT_INIT_AFTER, handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onGroupChangeBefore = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductVariants.EVENT_GROUP_CHANGE_BEFORE, handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onGroupChangeAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductVariants.EVENT_GROUP_CHANGE_AFTER, handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onGroupOptionChangeBefore = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_BEFORE, handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onGroupOptionChangeAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_AFTER, handler, priority, ignoreCancel, this);
        return this;
    };

    this.onInitAfter(function() {
        this.setCurrentGroup(this.getCurrentGroup());
        this.setCurrentGroupOption(this.getCurrentGroupOption());
    }.bind(this));

    this._selection = new AitiProductVariantsSelection(this);
};

/** EVENTS */
AitiProductVariants.EVENT_INIT_AFTER = 'product_variants_init_after';
AitiProductVariants.EVENT_GROUP_CHANGE_BEFORE = 'product_group_change_before';
AitiProductVariants.EVENT_GROUP_CHANGE_AFTER = 'product_group_change_after';
AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_BEFORE = 'product_group_option_change_before';
AitiProductVariants.EVENT_GROUP_OPTION_CHANGE_AFTER = 'product_group_option_change_after';

export default AitiProductVariants;
